import { makeStyles } from '@fluentui/react-components';

export const useStyles = makeStyles({
    sidebar: {
        height: '100%',
    },
});
